// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.diglog-card .el-form-item__label{\n  line-height: 36px;\n}\n.diglog-card .el-form-item {\n  margin-bottom: 10px;\n}\n.diglog-card .el-dialog {\n  border-radius: 12px;\n}\n.diglog-card .el-dialog__title {\n  padding-left: 24px;\n  color: #3855F1;\n}\n.diglog-card .section-title {\n  margin-top: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
